import { FC, useEffect, useState } from 'react';
import { Marker, useMap } from 'react-leaflet';
import * as L from 'leaflet';
import { createUserMarker } from '../../../../components/MarkerIcon/MarkerIcon';

interface IProps {}
const CurrentUserLocation: FC<IProps> = () => {
  const [position, setPosition] = useState<L.LatLng | null>(null);

  const map = useMap();

  useEffect(() => {
    const userLocation = map.locate({
      watch: true,
      // setView: true
    });

    userLocation.on('locationfound', function (e) {
      setPosition(e.latlng);
      console.log('locationfound');
      map.flyTo(e.latlng, position ? map.getZoom() : 19);
    });
    return () => {
      userLocation.stopLocate();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map]);

  if (!position) {
    return null;
  }

  return <Marker position={position} icon={createUserMarker()} />;
};

export default CurrentUserLocation;
